// Mirror of api/Services/SlugNormalizer.cs. The two MUST stay in sync --
// otherwise FE-built profile URLs (in admin lists or anywhere we have a
// display name but no stageNameNormalized field) won't match what the API
// looks up against Person.StageNameNormalized.

// U+0300..U+036F is the Combining Diacritical Marks Unicode block.
// Built via RegExp constructor with explicit \u escapes so the file stays
// ASCII-only on disk (avoids tooling that might mangle literal combining marks).
const COMBINING_MARKS = new RegExp("[\\u0300-\\u036f]", "g");

function foldDiacritics(input: string): string {
  // NFD decomposes "e" + U+0301 (combining acute) for accented Latin chars.
  // Then strip combining marks; remainder is the ASCII-equivalent base letter.
  return input.normalize("NFD").replace(COMBINING_MARKS, "");
}

/**
 * Build the canonical /u/{slug} suffix from a display name. Output matches
 * the backend SlugNormalizer.Normalize. Falls back to "profile" for empty input.
 *
 * Examples:
 *   slugifyStageName("Metis Matey") -> "metis-matey" (with accented e too)
 *   slugifyStageName("Jenni Gurl")  -> "jenni-gurl"
 *   slugifyStageName("")            -> "profile"
 */
export function slugifyStageName(name: string | null | undefined): string {
  if (!name) return "profile";
  const folded = foldDiacritics(String(name).trim());
  const lowered = folded.toLowerCase();
  const replaced = lowered.replace(/[\s_.]+/g, "-");
  const cleaned = replaced.replace(/[^a-z0-9-]/g, "");
  const collapsed = cleaned.replace(/-+/g, "-").replace(/^-|-$/g, "");
  return collapsed || "profile";
}

/** Convenience for `/u/{slug}` URL construction. */
export function profileHref(name: string | null | undefined): string {
  return `/u/${slugifyStageName(name)}`;
}
